const exportedObject = {
  consultarAseguradoData: {},
  consultarAseguradoLoading: false,
  consultarAseguradoError: null,

  limpiarDatosAseguradoLoading: false,
};

export default exportedObject;